var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1989 17.5947V23.6153C24.1989 23.7871 24.1641 23.9573 24.0966 24.1161C24.029 24.2749 23.93 24.4192 23.8052 24.5407C23.6804 24.6623 23.5322 24.7587 23.3691 24.8245C23.206 24.8902 23.0312 24.9241 22.8547 24.9241H14.7895C14.433 24.9241 14.0911 24.7862 13.839 24.5407C13.5869 24.2953 13.4453 23.9624 13.4453 23.6153V15.7623C13.4453 15.4152 13.5869 15.0823 13.839 14.8368C14.0911 14.5914 14.433 14.4535 14.7895 14.4535H20.4177M22.5859 12.3594H26.3496V16.0241M18.8221 19.6888L26.0808 12.6211",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.72d3bbca44638d80cdf8fc818b11d4c2.svg";
export { ForwardRef as ReactComponent };